'use strict';/* global define */define('modules/core/modules/app/services/environment/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     factory.$inject = ["ENVIRONMENT"];
function factory(ENVIRONMENT){// jshint validthis:true
// jshint latedef:false
var environment=ENVIRONMENT;return{get:get,isProduction:isProduction};/**
     * Is current frontend running in production environment
     * @return {Boolean} is production
     */function isProduction(){return environment==='production';}/**
     * Get environment string
     * @return {String} environment string
     */function get(){return environment;}}module.exports=factory;});
